var render = function render(_c,_vm){return _c('span',{staticClass:"status-box"},[(_vm.props.value)?_c('div',{staticClass:"status-box__item status-box__item_success"}):_c('div',{staticClass:"status-box__item status-box__item_error"})])
}
var staticRenderFns = []

export { render, staticRenderFns }